<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="secretariat-page">
    <div class="page-header">
      <h1>دبیرخانه</h1>
      <p>مدیریت مکاتبات و اسناد اداری</p>
    </div>
    
    <div class="content-grid">
      <div class="card">
        <div class="card-header">
          <h3>مکاتبات ورودی</h3>
        </div>
        <div class="card-body">
          <p>مدیریت نامه‌ها و اسناد دریافتی</p>
          <BaseButton title="مشاهده مکاتبات" variant="primary" type="button" />
        </div>
      </div>
      
      <div class="card">
        <div class="card-header">
          <h3>مکاتبات خروجی</h3>
        </div>
        <div class="card-body">
          <p>مدیریت نامه‌ها و اسناد ارسالی</p>
          <BaseButton title="مشاهده مکاتبات" variant="primary" type="button" />
        </div>
      </div>
      
      <div class="card">
        <div class="card-header">
          <h3>آرشیو اسناد</h3>
        </div>
        <div class="card-body">
          <p>ذخیره و بازیابی اسناد</p>
          <BaseButton title="دسترسی به آرشیو" variant="primary" type="button" />
        </div>
      </div>
      
      <div class="card">
        <div class="card-header">
          <h3>گزارش‌ها</h3>
        </div>
        <div class="card-body">
          <p>گزارش‌های آماری دبیرخانه</p>
          <BaseButton title="مشاهده گزارش‌ها" variant="primary" type="button" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import BaseButton from '@/components/UiCompunents/BaseButton.vue'
// منطق کامپوننت دبیرخانه
</script>

<style scoped>
.secretariat-page {
  padding: 2rem;
  direction: rtl;
}

.page-header {
  margin-bottom: 2rem;
  text-align: center;
}

.page-header h1 {
  color: var(--text-color-primary);
  margin-bottom: 0.5rem;
}

.page-header p {
  color: var(--text-color-secondary);
}

.content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.card {
  background: var(--background-color);
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  padding: 1.5rem;
  transition: transform 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.card-header h3 {
  color: var(--text-color-primary);
  margin-bottom: 1rem;
}

.card-body p {
  color: var(--text-color-secondary);
  margin-bottom: 1rem;
}

</style>
